import type { DataRow } from "../types";

export function buildCompositeKey(row: DataRow, fields: string[]): string {
  const fieldCount = fields.length;
  if (fieldCount === 0) {
    return "";
  }

  if (fieldCount === 1) {
    return String(row[fields[0]]);
  }

  if (fieldCount === 2) {
    return String(row[fields[0]]) + "_" + String(row[fields[1]]);
  }

  if (fieldCount === 3) {
    return (
      String(row[fields[0]]) +
      "_" +
      String(row[fields[1]]) +
      "_" +
      String(row[fields[2]])
    );
  }

  const parts = new Array<string>(fieldCount);
  for (let index = 0; index < fieldCount; index += 1) {
    parts[index] = String(row[fields[index]]);
  }

  return parts.join("_");
}

export function areFieldListsEqual(a: string[], b?: string[]): boolean {
  if (!b || a.length !== b.length) {
    return false;
  }

  if (a === b) {
    return true;
  }

  for (let index = 0; index < a.length; index += 1) {
    if (a[index] !== b[index]) {
      return false;
    }
  }

  return true;
}
